import { cn } from "@/lib/cn";

type Tone = "sale" | "new" | "low-stock" | "neutral";

const tones: Record<Tone, string> = {
  sale: "bg-[color:var(--color-primary)] text-white",
  new: "bg-[color:var(--color-secondary)] text-white",
  "low-stock": "bg-[color:var(--color-accent)] text-[color:var(--color-secondary)]",
  neutral: "bg-[color:var(--color-surface-alt)] text-[color:var(--color-text)]",
};

type Props = {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
};

export default function Badge({ tone = "neutral", className, children }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-[var(--radius-pill)] px-2.5 py-1 text-xs font-medium tracking-wide uppercase",
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
